import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import ListItemTestResult from "@common/ListItemTestResult";
import ShortcutLink from "@common/ShortcutLink";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import useCurrentConcept from "@hooks/useCurrentConcept";
import {TemplateContext} from "@common/context/TemplateContext";

const TeacherActiveLessonsWidget = props => {
    const {className} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {singlePage} = useContext(TemplateContext);
    const {loadCurrentConcept} = useCurrentConcept();
    const [classesProps, setClassesProps] = useState([]);
    const [classId, setClassId] = useState(user.classId);
    const [enabledConcepts, setEnabledConcepts] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const currentClass = user.classes.findIndex(clazz => clazz.classId == user.classId);
        let newClassesProps = {
            defaultSelected: currentClass == -1 ? 0 : currentClass,
            options: []
        };
        user.classes.map(clazz => {
            let option = {
                value: clazz.classId,
                label: clazz.className
            }
            newClassesProps.options.push(option);
        });
        setClassesProps(newClassesProps);
    }, [user]);

    useEffect(() => {
        if (classId && user.syllabusId) {
            setLoading(true);
            axios.get('/web/ui/content/class/' + classId + '/syllabus/'+ user.syllabusId + '/enabledTeacherConcepts')
                .then(response => {
                    const updateEnabledConcepts = response.data;
                    setEnabledConcepts(updateEnabledConcepts);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [classId]);

    const handleChange = selectedOption => {
        setClassId(selectedOption.value);
    }

    const handleSelectConcept = (conceptId) => {
        if (conceptId) {
            if (singlePage) {
                loadCurrentConcept(conceptId);
            } else {
                window.location.href = '/controlCentre/navigateSyllabuses.action?conceptId=' + enabledConcept.conceptId;
            }
        }
    }

    return (
        <DashboardWidget
            title={
                <span>Active {brandConfig.conceptsName}</span>
            }
            className={className}
            isLoading={isLoading}
            headerObjects={[{componentName: 'ButtonSelect', otherProps: {position: 'right', options: classesProps.options, title: 'Class', value: classesProps.defaultSelected !== undefined ? classesProps.options[classesProps.defaultSelected] : '', onChange: handleChange}}]}
        >
            <div className={'ch-dashboard-blk-body'}>
                {enabledConcepts.length > 0 &&
                    <div style={{marginTop: '5px'}}>
                        {enabledConcepts.map((enabledConcept, index) => (
                            <div key={enabledConcept.conceptId}  className="ch-dashboard-lesson-link">
                                {enabledConcept.syllabusName}<span className="material-icons">chevron_right</span>{enabledConcept.topicName}<span className="material-icons">chevron_right</span><span className="ch-shortcut-link ch-highlight" onClick={() => {handleSelectConcept(enabledConcept.conceptId)}}>{enabledConcept.conceptName}</span>
                            </div>
                        ))}
                    </div>
                }
                {enabledConcepts.length == 0 &&
                    <div className="ch-list-item-disabled">No active {brandConfig.conceptsName}</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default TeacherActiveLessonsWidget;